export const COUNTRIES = {
  pakistan: "Pakistan",
  costa_rica: "Costa Rica",
  peru: "Peru",
};

export const COUNTRIES_LIST = Object.values(COUNTRIES);

export const COUNTRIES_URL_MAPPING = Object.entries(COUNTRIES).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});
